import React from 'react';

const SessionContext = React.createContext(null);

SessionContext.displayName = 'SessionContext';

export default SessionContext;
